import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star } from 'lucide-react';

export const Testimonials = () => {
  const testimonials = [
    {
      name: 'Henry K.',
      rating: 5,
      text: 'Good service! Got YouTube Premium at half price.'
    },
    {
      name: 'Mira S.',
      rating: 5,
      text: 'Fck Big corporations. Good job!'
    },
    {
      name: 'Sofia P.',
      rating: 5,
      text: 'Saved so much.'
    },
    {
      name: 'Lia',
      rating: 5,
      text: 'Cheap and reliable.'
    },
    {
      name: 'Manny',
      rating: 5,
      text: 'Was skeptical at first but he proved me wrong!'
    }
  ];

  return (
    <section className="py-20 px-4">
      <div className="container mx-auto">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-foreground">
            What Our <span className="gradient-text">Customers</span> Say
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Join thousands of satisfied customers enjoying premium subscriptions
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="glass-card hover-glow">
              <CardContent className="p-6 space-y-4">
                {/* Star Rating */}
                <div className="flex gap-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star color="gold" key={i} className="w-4 h-4 fill-warning text-warning" />
                  ))}
                </div>
                
                {/* Testimonial Text */}
                <p className="text-sm text-muted-foreground leading-relaxed italic">
                  "{testimonial.text}"
                </p>
                
                {/* Customer Name */}
                <p className="text-sm font-semibold text-foreground">
                  — {testimonial.name}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
